//
//
//
//
import error404 from '@/assets/images/error-page/error-500.svg';
import errorContent from './error-content.vue';
export default {
  name: 'error_500',
  components: {
    errorContent: errorContent
  },
  data: function data() {
    return {
      src: error404
    };
  }
};